import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ShortcutInput } from 'ng-keyboard-shortcuts';

export interface IActionButton {
  action: string;
  icon: string;
  tooltip: string;
  loading?: boolean;
  id?: string;
  dataTestId?: string;
  roundButton?: boolean;
  buttonText?: string;
}

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent implements AfterViewInit, OnInit {
  @Input() buttons: IActionButton[] = [];
  @Input() rightAlign = 14;
  @Input() disabled = false;
  @Output() clickAction = new EventEmitter<string>();

  shortcuts: ShortcutInput[] = [];
  roundSpeedDial = false;
  buttonText = '';
  MultipleButtonText: string[] = [];
  minWidth: string[] = [];
  minHight: string[] = [];
  ngAfterViewInit() {
    this.shortcuts.push({
      key: ['alt + e'],
      label: 'Expand/Collapse Speed Dial',
      description: 'Alt + e',
      command: () => this.clickOnSpeedDial(),
      preventDefault: true,
    });
  }

  ngOnInit() {
    this.initializeButtonDetails();
    if (this.buttons && this.buttons.length == 1) {
      const isRoundButton = this.buttons[0]?.roundButton;
      if (isRoundButton && isRoundButton == true) {
        this.roundSpeedDial = true;
      } else {
        this.roundSpeedDial = false;
        this.buttonText = this.buttons[0].buttonText
          ? this.buttons[0].buttonText
          : this.buttons[0].tooltip;
      }
    } else {
      this.roundSpeedDial = false;
    }
  }

  initializeButtonDetails() {
    this.buttons.forEach((button, index) => {
      this.MultipleButtonText[index] = button.buttonText
        ? button.buttonText
        : button.tooltip;
      this.minWidth[index] = this.getMinWidth(index);
      this.minHight[index] = this.getMinHeight(index);
    });
  }

  onClickAction(e: string) {
    this.clickAction.emit(e);
  }

  clickOnSpeedDial() {
    document.getElementById('speedDialButton').click();
  }
  getMinWidth(index: number): string {
    const baseWidth = 180;
    const increment = 20;
    const calculatedWidth = baseWidth + increment * index;
    return `${calculatedWidth}px`;
  }
  getMinHeight(index: number): string {
    const baseHeight = 110;
    const increment = 50;
    const calculatedHeight = baseHeight + increment * index;
    return `${calculatedHeight}px`;
  }
}
